import { useStore, State } from 'store';

const selector = (state: State) => {
  return state.startWorkflow.submit.overallSubmitAsync.status;
};

export default function useStartAcyncStatus() {
  return useStore(selector);
}
